import { useState } from "react";

import { Flex, Modal, Radio, Typography, message } from "antd";

import styles from "./patient_case.module.scss";

import type { RadioChangeEvent } from "antd";

interface PapLanguageModalProps {
	open: boolean;
	entityID: string | number;
	onClose: () => void;
	onPrint: (entityID: string | number, pdftype: number) => Promise<void>;
}

export function PapLanguageModal({
	open,
	entityID,
	onClose,
	onPrint,
}: PapLanguageModalProps) {
	const [pdftype, setPdftype] = useState(6);
	const [printing, setPrinting] = useState(false);

	const handlePrint = async () => {
		setPrinting(true);
		try {
			await onPrint(entityID, pdftype);
			onClose();
		} catch (err: unknown) {
			message.error(
				err instanceof Error ? err.message : "Print failed"
			);
		} finally {
			setPrinting(false);
		}
	};

	return (
		<Modal
			title="PAP form language"
			open={open}
			centered
			width={380}
			className={styles.modal}
			onCancel={onClose}
			onOk={() => {
				void handlePrint();
			}}
			okText="Print"
			confirmLoading={printing}
			maskClosable={!printing}
			destroyOnClose
		>
			<Flex vertical gap={10}>
				<Typography.Text type="secondary">
					Choose English or Spanish for the manufacturer PAP form.
				</Typography.Text>
				<Radio.Group
					className={styles.optionGroup}
					value={pdftype}
					onChange={(event: RadioChangeEvent) => {
						setPdftype(event.target.value as number);
					}}
				>
					<Radio value={6}>English</Radio>
					<Radio value={12}>Spanish</Radio>
				</Radio.Group>
			</Flex>
		</Modal>
	);
}
